export enum ProcessDetailsTab {
  FILES = 'FILES',
  MESSAGES = 'MESSAGES',
  OFFER_INSTANCES = 'OFFER_INSTANCES',
  TASKS = 'TASKS',
}
